import { render, staticRenderFns } from "./insight.vue?vue&type=template&id=3f3daef0&scoped=true&"
import script from "./insight.vue?vue&type=script&lang=js&"
export * from "./insight.vue?vue&type=script&lang=js&"
import style1 from "./insight.vue?vue&type=style&index=1&id=3f3daef0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3daef0",
  null
  
)

export default component.exports